import tab_calendar from '../../../public/tab_calendar.svg';
import tab_chat from '../../../public/tab_chat.svg';
import tab_home from '../../../public/tab_home.svg';
import tab_list from '../../../public/tab_list.svg';
import tab_option from '../../../public/tab_option.svg';
import tab_ribbon from '../../../public/tab_ribbon.svg';
import tab_user from '../../../public/tab_user.svg';
import { useAuth, useTeller } from '@raysee/hooks';
import { PlanType } from '@raysee/schema';
import Image from 'next/legacy/image';
import Link from 'next/link';

type MenuKey = 'home' | 'rooms' | 'schedules' | 'plans' | 'options' | 'mypage' | 'users';

const Menus = [
  {
    key: 'home',
    image: tab_home,
    title: 'ホーム',
    path: '/',
  },
  {
    key: 'rooms',
    image: tab_chat,
    title: 'チャット',
    path: '/rooms',
  },
  {
    key: 'users',
    image: tab_list,
    title: 'ユーザー',
    path: '/users',
  },
  {
    key: 'schedules',
    image: tab_calendar,
    title: '待機',
    path: '/schedules',
  },
  {
    key: 'plans',
    image: tab_ribbon,
    title: 'メニュー',
    path: '/plans',
  },
  {
    key: 'options',
    image: tab_option,
    title: 'オプション',
    path: '/options',
  },
  {
    key: 'mypage',
    image: tab_user,
    title: 'マイページ',
    path: '/mypage',
  },
];

interface Props {
  selected: MenuKey;
}

const TabBar = ({ selected }: Props) => {
  const [auth] = useAuth();
  const [teller] = useTeller(auth?.uid);
  const isHoldChatPlan = teller && teller.planTypes.includes(PlanType.Chat);
  const hasPhonePlanType = !!teller?.planTypes?.includes(PlanType.Phone);
  const menus = Menus.filter((menu) => {
    if (menu.key === 'schedules') return hasPhonePlanType;
    else if (menu.key === 'users') return !!teller?.isPro;
    return true;
  });

  return (
    <nav
      className={`sticky bottom-0 z-50 grid border-t bg-white py-3 ${
        menus.length === 7 ? 'grid-cols-7' : menus.length === 6 ? 'grid-cols-6' : 'grid-cols-5'
      }`}
    >
      {menus.map((menu, i) => {
        if (!isHoldChatPlan && menu.key === 'first_plan') return;
        return (
          <Link href={menu.path} key={i} legacyBehavior>
            <a className={selected !== menu.key && 'opacity-40'}>
              <div className="flex flex-col items-center">
                <Image src={menu.image} width="28" height="28" alt={menu.title} />
                <span className="text-xs font-semibold text-gray-600">{menu.title}</span>
              </div>
            </a>
          </Link>
        );
      })}
    </nav>
  );
};

export { TabBar };
